import { HttpInterceptorFn, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { LOADING_CONTEXT } from './loading-context.token';
import { environment } from '../../environments';

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const loadingService = inject(LoadingService);

  const apiBaseUrl = environment.apiBaseUrl || '/api';
  const isApiCall = req.url.startsWith(apiBaseUrl);
  if (!isApiCall) return next(req);

  const context = req.context.get(LOADING_CONTEXT);
  if (context === 'none') return next(req);

  loadingService.show(context);
  return next(req).pipe(
    finalize(() => loadingService.hide(context))
  );
};
